import { Router } from "vue-router";

import { permission } from "./permission/permission";
import { tokenPermission } from "./permission/token";
import { initAxios } from "./request";

export default function init(body: Body) {
  tokenPermission(body.router);
  permission(body.router);
  initAxios();
}
interface Body {
  router?: Router;
}
